import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import GoToTop from '../Components/GoToTop'

export default function Layout(props) {
  return (
    <React.Fragment>
      <Navbar />
      <div className='content'>
        {props.page}
      </div>
      <Footer />
      <GoToTop />
    </React.Fragment>
  )
}
